export const GUEST_CART_STORAGE_KEY = 'dindin.guestCart.v1';

